"use client";

import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { motion } from "framer-motion";
import Container from "../../wrapper/Container";
import SectionSubHeading from "../titles/SectionSubHeading";
import SectionTitle from "../titles/SectionTitle";
import ServiceSliverRail from "./ServiceSliverRail";
import { ServicesData } from "@/data/ServicesData";
import { ArrowUpRight } from "lucide-react";
interface ServicesCardProps {
  // Driven by the parent's scroll progress. The left copy crossfades on change;
  // the right rail opens the matching slab. No horizontal motion.
  activeIndex: number;
}
const ServicesCard = t0 => {
  const $ = _c(9);
  const {
    activeIndex
  } = t0;
  let t1;
  if ($[0] !== activeIndex) {
    t1 = ServicesData.map((data, index) => {
      const isActive = index === activeIndex;
      const exploreLabel = data.title.replace(/\.$/, "").toLowerCase().replace(/\b\w/g, _temp);
      return <motion.div key={data.id} className="col-start-1 row-start-1 w-full space-y-4 lg:space-y-4" initial={false} animate={{
        opacity: isActive ? 1 : 0
      }} transition={{
        duration: 0.5,
        ease: "easeInOut"
      }} style={{
        zIndex: isActive ? 10 : 0,
        pointerEvents: isActive ? "auto" : "none"
      }}><div className="space-y-2"><SectionSubHeading subtitle="Offered Services" className="text-white" /><SectionTitle title={data.title} className="text-white wrap-break-word max-w-50 md:max-w-none text-4xl" /></div><p className="text-md md:text-base lg:text-lg text-white leading-relaxed font-normal max-w-[90%] lg:max-w-xl wrap-break-word">{data.description}</p><ul className="lg:space-y-3 space-y-2 pt-4 w-full">{data.features.map(_temp2)}</ul><div className="shrink-0 pt-2"><Link className="text-primary flex items-center gap-1 text-lg group border-b border-transparent transition-all duration-500 w-fit relative after:absolute after:bottom-0 after:left-0 after:h-0.5 after:w-0 after:bg-primary after:transition-all after:duration-300 after:content-[''] hover:after:w-full mb-4" href={`/services/${data.slug}`}><span>Explore {exploreLabel}</span>{" "}<ArrowUpRight className="w-5 h-5 md:w-6 md:h-6" /></Link></div></motion.div>;
    });
    $[0] = activeIndex;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <div className="relative grid w-full max-w-full lg:w-[55%]">{t1}</div>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== activeIndex) {
    t3 = <div className="relative hidden h-[64vh] w-full md:w-[45%] lg:block"><ServiceSliverRail services={ServicesData} activeIndex={activeIndex} /></div>;
    $[4] = activeIndex;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2 || $[7] !== t3) {
    t4 = <Container className="flex flex-col md:flex-row justify-between items-start gap-10 lg:gap-16 px-4 lg:px-10">{t2}{t3}</Container>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
};
export default ServicesCard;
function _temp(c) {
  return c.toUpperCase();
}
function _temp2(feature, i) {
  return <li key={i} className="flex items-center gap-4"><span className="w-2.5 h-2.5 rounded-full bg-white shrink-0" /><span className="text-md md:text-base lg:text-lg font-medium text-zinc-300">{feature}</span></li>;
}